var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import filter from "@domains/utils/filter";
import { totalDaysPnlPerc, totalPnlPerc } from "@domains/utils/holdings";
import { findObjectsByValue } from "@domains/utils/search";
import sort, { ESortOrder, stringSort_depricated } from "@domains/utils/sort";
import summarize from "@domains/utils/summarize";
var HoldingCommonUseCase = /** @class */ (function () {
    function HoldingCommonUseCase(searchUsecase, filterUsecase, sortUseCase, summarizeUseCase, dashboardSummarizeUseCase) {
        this.searchUsecase = searchUsecase;
        this.filterUsecase = filterUsecase;
        this.sortUseCase = sortUseCase;
        this.summarizeUseCase = summarizeUseCase;
        this.dashboardSummarizeUseCase = dashboardSummarizeUseCase;
    }
    HoldingCommonUseCase.prototype.dashboardSummarize = function (dashboardData, isSummarize) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.dashboardSummarizeUseCase.getSummarizedData(dashboardData, isSummarize)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    HoldingCommonUseCase.prototype.getModifiedData = function (holdingReportData, combinedState) {
        return __awaiter(this, void 0, void 0, function () {
            var searchData, filterData, sortedData, summerizeData, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 5, , 6]);
                        return [4 /*yield*/, this.searchUsecase.getSearchData(holdingReportData, combinedState.searchState)];
                    case 1:
                        searchData = _a.sent();
                        return [4 /*yield*/, this.filterUsecase.getFilteredData(searchData, combinedState.filterUiState)];
                    case 2:
                        filterData = _a.sent();
                        return [4 /*yield*/, this.sortUseCase.getSortedData(filterData, combinedState.sortDataUiState)];
                    case 3:
                        sortedData = _a.sent();
                        return [4 /*yield*/, this.summarizeUseCase.getSummarizedData(sortedData, combinedState.isSummarize)];
                    case 4:
                        summerizeData = _a.sent();
                        return [2 /*return*/, summerizeData];
                    case 5:
                        error_1 = _a.sent();
                        console.log(error_1);
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    return HoldingCommonUseCase;
}());
export default HoldingCommonUseCase;
var SearchUseCase = /** @class */ (function () {
    function SearchUseCase() {
    }
    SearchUseCase.prototype.getSearchData = function (holdingReportData, searchData) {
        var HoldingDetails = findObjectsByValue(holdingReportData.HoldingDetails, searchData);
        return __assign(__assign({}, holdingReportData), { HoldingDetails: HoldingDetails, SearchData: searchData });
    };
    return SearchUseCase;
}());
export { SearchUseCase };
var FilterUseCase = /** @class */ (function () {
    function FilterUseCase() {
    }
    FilterUseCase.prototype.getFilteredData = function (holdingReportData, _a) {
        var _b, _c;
        var simpleFilter = _a.simpleFilter, assetFilter = _a.assetFilter, productAssetFilter = _a.productAssetFilter;
        var summary;
        var FilterData = [];
        var isAssetFiltersApplied = false;
        var isSimpleFiltersApplied = false;
        var isProductFilterAppiled = false;
        var filterStateForProductAssests = [{ key: ["quote", "edelweissProductCode"], value: [] }];
        var filterStateForAssests = [{ key: ["quote", "assetCode"], value: [] }];
        assetFilter.filters.forEach(function (filter) {
            if (filter.selected) {
                isAssetFiltersApplied = true;
                filterStateForAssests[0].value.push(filter.key);
            }
        });
        if (isAssetFiltersApplied) {
            FilterData = filter(holdingReportData.HoldingDetails, filterStateForAssests);
        }
        productAssetFilter === null || productAssetFilter === void 0 ? void 0 : productAssetFilter.filters.forEach(function (filter) {
            if (filter.selected) {
                isProductFilterAppiled = true;
                filterStateForProductAssests[0].value.push(filter.key);
            }
        });
        if (isProductFilterAppiled) {
            FilterData = filter(isAssetFiltersApplied ? FilterData : holdingReportData.HoldingDetails, filterStateForProductAssests);
        }
        var simpleFilterState = [];
        simpleFilter.filters.forEach(function (filter) {
            if (filter.selected) {
                isSimpleFiltersApplied = true;
                simpleFilterState.push({
                    key: ["filterFlags", filter.key],
                    value: true,
                });
            }
        });
        if (isSimpleFiltersApplied) {
            FilterData = filter(isAssetFiltersApplied || isProductFilterAppiled
                ? FilterData
                : holdingReportData.HoldingDetails, simpleFilterState);
        }
        // if (
        //   isSimpleFiltersApplied &&
        //   (isAssetFiltersApplied || isProductFilterAppiled)
        // ) {
        //   var mergedData = simpleFilterData.concat(
        //     assetFilterData,
        //     productassetFilterData
        //   );
        //   filteredData = mergedData.filter((item, index) => {
        //     return mergedData.indexOf(item) == index;
        //   });
        // } else if (isSimpleFiltersApplied) {
        //   filteredData.push(...simpleFilterData);
        // } else if (isAssetFiltersApplied) {
        //   filteredData.push(...assetFilterData);
        // } else {
        //   filteredData = holdingReportData.HoldingDetails;
        // }
        if (isSimpleFiltersApplied ||
            isAssetFiltersApplied ||
            isProductFilterAppiled) {
            var totalInvestment_1 = 0, currentValue_1 = 0, totalPnL_1 = 0, daysPnL_1 = 0;
            FilterData.map(function (x) {
                totalInvestment_1 = totalInvestment_1 + Number(x.investmentValue);
                currentValue_1 = currentValue_1 + Number(x.currentValue);
                totalPnL_1 = totalPnL_1 + Number(x.pnl);
                daysPnL_1 = daysPnL_1 + Number(x.dayChange);
            });
            summary = __assign(__assign({}, holdingReportData.HoldingSummary), { totalInvestment: totalInvestment_1, currentValue: currentValue_1, totalPnL: totalPnL_1, daysPnL: daysPnL_1, totalPnLChange: totalPnlPerc(totalPnL_1, totalInvestment_1), daysPnLChange: totalDaysPnlPerc(daysPnL_1, (_c = (_b = holdingReportData === null || holdingReportData === void 0 ? void 0 : holdingReportData.HoldingSummary) === null || _b === void 0 ? void 0 : _b.totalPreviousClosingValue) === null || _c === void 0 ? void 0 : _c.valueOf()) });
        }
        else {
            FilterData = holdingReportData.HoldingDetails;
            summary = holdingReportData.HoldingSummary;
        }
        return __assign(__assign({}, holdingReportData), { HoldingDetails: FilterData, HoldingSummary: summary, FilterData: { simpleFilter: simpleFilter, assetFilter: assetFilter, productAssetFilter: productAssetFilter } });
    };
    return FilterUseCase;
}());
export { FilterUseCase };
var SortUseCase = /** @class */ (function () {
    function SortUseCase() {
    }
    SortUseCase.prototype.getSortedData = function (data, sortState) {
        var HoldingDetails;
        if (sortState.sortName == "displayName") {
            HoldingDetails = stringSort_depricated(data.HoldingDetails, sortState.sortName, sortState.order);
        }
        else {
            HoldingDetails = sort(data.HoldingDetails, sortState.sortName, sortState.order);
        }
        var SortData = data.SortData.map(function (e) { return (__assign(__assign({}, e), { order: sortState.sortName === e.sortName
                ? sortState.order
                : ESortOrder.UNCHANGED })); });
        return __assign(__assign({}, data), { HoldingDetails: HoldingDetails, SortData: SortData });
    };
    return SortUseCase;
}());
export { SortUseCase };
var SummarizedUseCase = /** @class */ (function () {
    function SummarizedUseCase() {
    }
    SummarizedUseCase.prototype.getSummarizedData = function (data, isSummarize) {
        return __awaiter(this, void 0, void 0, function () {
            var HoldingSummary, HoldingDetails, IsSummarize;
            return __generator(this, function (_a) {
                if (isSummarize) {
                    HoldingSummary = data.HoldingSummary, HoldingDetails = data.HoldingDetails, IsSummarize = data.IsSummarize;
                    HoldingSummary = __assign(__assign({}, HoldingSummary), { totalInvestment: summarize(Number(HoldingSummary.totalInvestment)), currentValue: summarize(Number(HoldingSummary.currentValue)), totalPnL: summarize(Number(HoldingSummary.totalPnL)), daysPnL: summarize(Number(HoldingSummary.daysPnL)) });
                    HoldingDetails = HoldingDetails.map(function (HoldingDetail) {
                        return __assign(__assign({}, HoldingDetail), { averagePrice: summarize(HoldingDetail.averagePrice), CUSA: summarize(HoldingDetail.cusa), currentValue: summarize(HoldingDetail.currentValue), dayChange: summarize(HoldingDetail.dayChange), freeQuantity: summarize(HoldingDetail.freeQuantity), investmentValue: summarize(HoldingDetail.investmentValue), lasPledge: summarize(HoldingDetail.lasPledge), lockedInQuantity: summarize(HoldingDetail.lockedInQuantity), mtfPledge: summarize(HoldingDetail.mtfPledge), normalMarginPledge: summarize(HoldingDetail.normalMarginPledge), pnl: summarize(HoldingDetail.pnl), quantity: summarize(HoldingDetail.quantity), safeKeepQuantity: summarize(HoldingDetail.safeKeepQuantity), sebiMtfHoldQuantity: summarize(HoldingDetail.sebiMtfHoldQuantity), soldQuantity: summarize(HoldingDetail.soldQuantity), t1: summarize(HoldingDetail.t1), t1Mtf: summarize(HoldingDetail.t1Mtf), tradableQuantity: summarize(HoldingDetail.tradableQuantity) });
                    });
                    IsSummarize = isSummarize;
                    return [2 /*return*/, Promise.resolve(__assign(__assign({}, data), { HoldingSummary: HoldingSummary, HoldingDetails: HoldingDetails, IsSummarize: IsSummarize }))];
                }
                return [2 /*return*/, data];
            });
        });
    };
    return SummarizedUseCase;
}());
export { SummarizedUseCase };
var DashboardHoldingSummarizedUseCase = /** @class */ (function () {
    function DashboardHoldingSummarizedUseCase() {
    }
    DashboardHoldingSummarizedUseCase.prototype.getSummarizedData = function (data, isSummarize) {
        return __awaiter(this, void 0, void 0, function () {
            var summarizeDashboard, holdingSummary;
            return __generator(this, function (_a) {
                if (isSummarize) {
                    summarizeDashboard = data.holdingDashboardSummary.map(function (x) {
                        return __assign(__assign({}, x), { investmentValue: summarize(Number(x.investmentValue)), marketValue: summarize(Number(x.marketValue)), pnl: summarize(Number(x.pnl)) });
                    });
                    holdingSummary = __assign(__assign({}, data.holdingSummary), { totalInvestment: summarize(Number(data.holdingSummary.totalInvestment)), currentValue: summarize(Number(data.holdingSummary.currentValue)), totalPnL: summarize(Number(data.holdingSummary.totalPnL)), daysPnL: summarize(Number(data.holdingSummary.daysPnL)) });
                    return [2 /*return*/, __assign(__assign({}, data), { holdingDashboardSummary: summarizeDashboard, holdingSummary: holdingSummary })];
                }
                return [2 /*return*/, data];
            });
        });
    };
    return DashboardHoldingSummarizedUseCase;
}());
export { DashboardHoldingSummarizedUseCase };
